import axios from 'axios'
import { pathOr, omit, isEmpty } from 'ramda'
import URLSearchParams from 'url-search-params'
import { change } from 'redux-form'
import { getApartmentId } from '../../../helpers/utils'
import setValue from './setValue'
import {
  dateFromURLParam,
  filledRooms as getFilledRooms,
  getActiveAmenities,
  getActivePrices,
  URLDateParam,
  dateEndFromNights,
  nightsFromPeriod,
} from '../../search/utils'
import {
  BUTTON_OFF,
  BUTTON_ON,
  FILTER_DATES,
  FILTER_MORE,
  FILTER_ROOMS,
  FILTER_SORT,
  FILTER_CODE,
  SEARCH_FILTERS_FORM,
  SEARCH_PARAM_AMENITIES,
  SEARCH_PARAM_DATE_END,
  SEARCH_PARAM_DATE_START,
  SEARCH_PARAM_HOTEL_TYPE,
  SEARCH_PARAM_KEYWORD,
  SEARCH_PARAM_PRICE_RANGE,
  SEARCH_PARAM_ROOM,
  SEARCH_PARAM_SORT,
  SEARCH_PARAM_APARTMENT_ID,
  SEARCH_PARAM_CLIENT_CODE,
  SEARCH_PARAM_CONTRACT_NUMBER,
  SEARCH_PARAM_IATA_CODE,
  SEARCH_PARAM_PROMO_CODE,
  DESTINATIONS_PAGE_VIEW,
  HOMEPAGE_VIEW,
  OFFERINDEXPAGE_VIEW,
  OFFERPAGE_VIEW,
  SEARCH_PARAM_TO_ROOM_RATES,
  SEARCH_PARAM_WRONGPROMO_CODE,
  BASICPAGE_VIEW,
  SEARCH_PARAM_ERROR_PROMO_CODE,
  DESTINATIONS_ALL_PAGE_VIEW,
} from '../../search/constants'
import { amenityFieldName, priceFieldName } from '../../search/components/Filters/FilterDetailed/constants'
import filterChange from '../../search/actions/filters/filterChange'
import priceChange from '../../search/actions/filters/priceChange'
import amenityChange from '../../search/actions/filters/amenityChange'
import hotelTypeChange from '../../search/actions/filters/hotelTypeChange'
import filterApply from '../../search/actions/filters/filterApply'
import openPopup from '../../PopupConstructor/actions/popupActions'
import {GLOBAL_ERROR_POPUP} from '../../PopupConstructor/constants'
import { PAGE_BF_FIRST_STEP, PAGE_HOTEL } from '../../../constants'
import { getRooms } from './getRooms'
import toggleGlobalLoader from '../../loader/actions/loaderActions'
import dataLayerPush from '../../../helpers/dataLayerPush'
import { searchResults, businessCodeFilter, tid } from '../drupalSettings'
import postBasket from './postBasket'
import getStore from '../store/getStore'
import { isDesktop } from '../../../helpers/browser'
import setSearchUrlFiltersHolder from '../../search/actions/setSearchUrlFiltersHolder'
import fetchHotelsList from 'js/apiCalls/hotelsList'
import {generateId} from 'js/helpers/generate';

const pageView = pathOr(null, ['drupalSettings', 'pageView'], window)
const isDestinationPage = pageView === DESTINATIONS_PAGE_VIEW
const isHomePage = pageView === HOMEPAGE_VIEW
const isBasicPage = pageView === BASICPAGE_VIEW
const isOfferPage =  pageView === OFFERPAGE_VIEW
const isOfferIndexPage =  pageView === OFFERINDEXPAGE_VIEW
const isDestinationsAllPage =  pageView === DESTINATIONS_ALL_PAGE_VIEW

let isFirstGetSearchResults = true

const appendTid = (URLParams) => {
  if (tid && URLParams) {
    URLParams.delete('tid')
    URLParams.append('tid', tid)
  }
  return URLParams
}

export const datesFilterInit = async (URLParams, dispatchParam, stateParam) => {
  const store = await getStore()
  const state = stateParam || store.getState()
  const dispatch = dispatchParam || store.dispatch

  const { form: { searchFilters: { dates, datesApply } } } = state

  let dateStart
  let dateEnd

  if (URLParams.has(SEARCH_PARAM_DATE_START) && URLParams.has(SEARCH_PARAM_DATE_END)) {
    dateStart = URLParams.get(SEARCH_PARAM_DATE_START)
    dateEnd = dateEndFromNights(dateStart, URLParams.get(SEARCH_PARAM_DATE_END))

    if (URLDateParam(dateStart) >= URLDateParam(dateEnd)) {
      dateStart = ''
      dateEnd = ''
    }
  }

  if (Array.isArray(dates) && dates.length === 2 && datesApply) {
    if (dateStart) {
      URLParams.delete(SEARCH_PARAM_DATE_START)
      URLParams.delete(SEARCH_PARAM_DATE_END)
    }

    URLParams.append(SEARCH_PARAM_DATE_START, URLDateParam(dates[0]))
    URLParams.append(SEARCH_PARAM_DATE_END, nightsFromPeriod(dates))

    if (isFirstGetSearchResults && isDestinationPage) {
      appendTid(URLParams)
    }
  } else if (dateStart && dateEnd) {
    await dispatch(filterChange(FILTER_DATES, [dateFromURLParam(dateStart), dateFromURLParam(dateEnd)]))
    dispatch(filterApply(FILTER_DATES, true))
  }
  return URLParams
}

export const roomsFilterInit = async (URLParams, dispatchParam, stateParam) => {
  const store = await getStore()
  const state = stateParam || store.getState()
  const dispatch = dispatchParam || store.dispatch

  const { form: { searchFilters: { rooms, roomsApply } } } = state
  let roomsParams

  if (URLParams.has(SEARCH_PARAM_ROOM) && URLParams.get(SEARCH_PARAM_ROOM) !== '') {
    roomsParams = URLParams.getAll(SEARCH_PARAM_ROOM)
  }

  const filledRooms = getFilledRooms(rooms)
    .map(r => ({
      adults: r.adults,
      children: r.children,
      babies: r.babies,
      id: r.id || generateId(),
    }))

  if (rooms && roomsApply) {
    URLParams.delete(SEARCH_PARAM_ROOM)
    filledRooms
      .forEach(room => URLParams.append(SEARCH_PARAM_ROOM, `${Object.values(room).join(',')}`))
    // append tid on Destinations Page only if adults was choosen
    if (isDestinationPage && rooms[0].adults !== 0 && !isFirstGetSearchResults) {
      appendTid(URLParams)
    }
  } else if (roomsParams) {
    const roomsToState = []
    roomsParams.forEach((room) => {
      const r = room.split(',')
      const guests = {
        adults: parseInt(r[0], 10),
        children: parseInt(r[1], 10),
        babies: parseInt(r[2], 10),
        visible: true,
        id: r[3] || generateId(),
      }
      roomsToState.push(guests)
    })
    await dispatch(filterChange(FILTER_ROOMS, roomsToState))
    await dispatch(filterApply(FILTER_ROOMS, true))
  }
  return URLParams
}

export const codeFilterInit = async (URLParams, dispatchParam, stateParam) => {
  const store = await getStore()
  const state = stateParam || store.getState()
  const dispatch = dispatchParam || store.dispatch

  const codeApply = pathOr(false, ['form', 'searchFilters', 'codeApply'], state)
  // check if user entered codes
  const clientCode = pathOr(false, ['form', 'searchFilters', 'code', 'clientCode'], state)
  const promoCode = pathOr(false, ['form', 'searchFilters', 'code', 'promoCode'], state)
  const errorPromo = pathOr(false, ['form', 'searchFilters', 'code', 'errorPromo'], state)
  const wrongPromoCodeApplied = pathOr(false, [SEARCH_PARAM_WRONGPROMO_CODE], businessCodeFilter)
  const gotError = pathOr(false, ['form', 'searchFilters', 'code', 'error'], state)

  const fieldsArray = [
    SEARCH_PARAM_CLIENT_CODE,
    SEARCH_PARAM_CONTRACT_NUMBER,
    SEARCH_PARAM_IATA_CODE,
    SEARCH_PARAM_PROMO_CODE,
    SEARCH_PARAM_WRONGPROMO_CODE,
    SEARCH_PARAM_ERROR_PROMO_CODE
  ]

  // Init code filter from drupalSettings
  // and dispatch code params into redux-form
  if ((!codeApply && !clientCode && !gotError) || (!codeApply && !promoCode && !gotError)) {
    fieldsArray.forEach((field) => {
      if (field === SEARCH_PARAM_WRONGPROMO_CODE && wrongPromoCodeApplied && !promoCode) {
        // we should show wrong promo code until user enter correct one or 15min passed
        dispatch(change(SEARCH_FILTERS_FORM, SEARCH_PARAM_PROMO_CODE, businessCodeFilter[SEARCH_PARAM_WRONGPROMO_CODE]))
        businessCodeFilter[SEARCH_PARAM_PROMO_CODE] = businessCodeFilter[SEARCH_PARAM_WRONGPROMO_CODE]
      } else if (promoCode && promoCode !== businessCodeFilter[SEARCH_PARAM_PROMO_CODE]) {
        businessCodeFilter[SEARCH_PARAM_PROMO_CODE] = promoCode
      } else if (field === SEARCH_PARAM_ERROR_PROMO_CODE && errorPromo) {
        businessCodeFilter[SEARCH_PARAM_ERROR_PROMO_CODE] = errorPromo
      } else {
        dispatch(change(SEARCH_FILTERS_FORM, field, businessCodeFilter[field]))
      }
    })

    await dispatch(filterChange(FILTER_CODE, businessCodeFilter))
  }

  await dispatch(filterApply(FILTER_CODE, true))
  // check if code was entered and add tid to url
  const isCodeEntered = pathOr(false, ['drupalSettings', 'businessCodeFilter', 'clientCode'], window)

  if (isCodeEntered && !isFirstGetSearchResults && isDestinationPage) {
    appendTid(URLParams)
  }
  return URLParams
}

const moreFilterInit = async (URLParams, dispatchParam, stateParam) => {
  const store = await getStore()
  const state = stateParam || store.getState()
  const dispatch = dispatchParam || store.dispatch

  const {
    form: {
      searchFilters: {
        more: { priceRange, amenities, hotelType },
        moreApply,
      },
    },
  } = state
  let applyByParams = false
  let priceRangeParam
  let amenitiesParam
  let hotelTypeParam

  /**
   * Price range
   */
  if (URLParams.has(SEARCH_PARAM_PRICE_RANGE)) {
    priceRangeParam = URLParams.get(SEARCH_PARAM_PRICE_RANGE)
  }

  if (priceRange && moreApply) {
    URLParams.delete(SEARCH_PARAM_PRICE_RANGE)
    const activePrices = getActivePrices(priceRange)
    if (activePrices.length) {
      URLParams.append(SEARCH_PARAM_PRICE_RANGE, activePrices.map(p => p[0]).join(','))
    }
  } else if (priceRangeParam) {
    priceRangeParam.split(',').forEach((value) => {
      dispatch(priceChange(priceFieldName(value), BUTTON_ON))
    })
    applyByParams = true
  }

  /**
   * Amenities
   */
  if (URLParams.has(SEARCH_PARAM_AMENITIES)) {
    amenitiesParam = URLParams.get(SEARCH_PARAM_AMENITIES)
  }

  if (amenities && moreApply) {
    URLParams.delete(SEARCH_PARAM_AMENITIES)
    const activeAmenities = getActiveAmenities(amenities)
    if (activeAmenities.length) {
      URLParams.append(SEARCH_PARAM_AMENITIES, activeAmenities.map(p => p[0]).join(','))
    }
  } else if (amenitiesParam) {
    amenitiesParam.split(',').forEach((value) => {
      dispatch(amenityChange(amenityFieldName(value), BUTTON_ON))
    })
    applyByParams = true
  }

  /**
   * Hotel type
   */
  if (URLParams.has(SEARCH_PARAM_HOTEL_TYPE)) {
    hotelTypeParam = URLParams.get(SEARCH_PARAM_HOTEL_TYPE)
  }

  if (hotelType && moreApply) {
    URLParams.delete(SEARCH_PARAM_HOTEL_TYPE)
    const activeHotelType = getActiveAmenities(hotelType);
    if (activeHotelType.length) {
      URLParams.append(SEARCH_PARAM_HOTEL_TYPE, activeHotelType.map(p => p[0]).join(','))
    }
  } else if (hotelTypeParam) {
    dispatch(hotelTypeChange(hotelTypeParam))
    applyByParams = true
  }

  if (applyByParams) {
    dispatch(filterApply(FILTER_MORE, true))
  }

  // Appednd tid
  if (isDestinationPage && !isFirstGetSearchResults) {
    appendTid(URLParams)
  }

  return URLParams
}

const sortFilterInit = async (URLParams, dispatchParam, stateParam) => {
  const store = await getStore()
  const state = stateParam || store.getState()
  const dispatch = dispatchParam || store.dispatch

  const { form: { searchFilters: { sort } } } = state

  let sortParam

  if (URLParams.has(SEARCH_PARAM_SORT)) {
    sortParam = parseInt(URLParams.get(SEARCH_PARAM_SORT), 10)
    if (isDestinationPage && !isFirstGetSearchResults) {
      appendTid(URLParams)
    }
  }

  if (sort) {
    URLParams.delete(SEARCH_PARAM_SORT)
    URLParams.append(SEARCH_PARAM_SORT, sort)
    if (isDestinationPage && !isFirstGetSearchResults) {
      appendTid(URLParams)
    }
  } else if (sortParam) {
    await dispatch(filterChange(FILTER_SORT, sortParam))
    dispatch(filterApply(FILTER_SORT, true))
  }

  if (isDestinationPage && !isFirstGetSearchResults) {
    appendTid(URLParams)
  }

  return URLParams
}

const getSearchResults = async (dispatch, getState, searchParams, init) => {
  const state = getState()
  const {
    main: {
      searchResultsKeyword,
      pageIndex,
    },
    browser,
  } = state
  const params = new URLSearchParams(window.location.search)

  const isInitialParamsEmpty = Array.from(params.entries()).length === 0
  dispatch(toggleGlobalLoader(true))

  if (searchResultsKeyword && !params.has(SEARCH_PARAM_KEYWORD)) {
    params.append(SEARCH_PARAM_KEYWORD, searchResultsKeyword)
  } else if (searchParams && !params.has('geoCode') && !params.has('geoType')) {
    const paramsGeoObj = new URLSearchParams(`${searchParams}`)
    params.append('geoCode', paramsGeoObj.get('geoCode'))
    params.append('geoType', paramsGeoObj.get('geoType'))
  }

  await datesFilterInit(params, dispatch, state)
  await roomsFilterInit(params, dispatch, state)
  await moreFilterInit(params, dispatch, state)
  await codeFilterInit(params, dispatch, state)
  await sortFilterInit(params, dispatch, state)

  // multiple booking apartment_id
  if (pageIndex === PAGE_BF_FIRST_STEP) {
    const apartmentParamArr = params.getAll(SEARCH_PARAM_ROOM)
    const activeApartmentId = params.get(SEARCH_PARAM_APARTMENT_ID)

    if (apartmentParamArr.length) {
      if (!activeApartmentId) {
        params.append(SEARCH_PARAM_APARTMENT_ID, getApartmentId(apartmentParamArr[0]))
      } else if (
        !apartmentParamArr.find(apartment => getApartmentId(apartment) === activeApartmentId)
      ) {
        params.set(SEARCH_PARAM_APARTMENT_ID, getApartmentId(apartmentParamArr[0]))
      }
    } else if (activeApartmentId) {
      searchParams.delete(SEARCH_PARAM_APARTMENT_ID)
    }
  }
  // end of multiple booking apartment_id
  params.delete('emptyCalendar')

  let paramsString = Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''

  // If paramsString is false and isHomePage or isBasicPage, do nothing.
  // Otherwise, update the URL with paramsString.  These if need to remove after slit file optimisation deployed
  // if (!paramsString === false && !(isHomePage || isBasicPage || isOfferPage || isOfferIndexPage || isDestinationsAllPage)) {
  //   window.history.replaceState({}, '', paramsString)
  // }

  let isSuccess = true
  let doReload = false

  switch (pageIndex) {
    case PAGE_BF_FIRST_STEP:
      await dispatch(postBasket({ getBasket: true }))

      if (isEmpty(pathOr({}, ['main', 'basket'], getState()))) {
        const apartmentParamArr = params.getAll(SEARCH_PARAM_ROOM)
        params.set(SEARCH_PARAM_APARTMENT_ID, getApartmentId(apartmentParamArr[0]))
        paramsString = Array.from(params.entries()).length > 0 ? `?${params.toString()}` : ''
        if (paramsString) {
          window.history.replaceState({}, '', paramsString)
        }
      }
      await getRooms(dispatch, state, paramsString, init)
      dispatch(toggleGlobalLoader(false))
      break
    case PAGE_HOTEL:
      isSuccess = true
      doReload = true
      break

    default:
      try {
        let data

        // api v3 request url
        const apiV3Url = pathOr('', ['drupalSettings', 'search', 'api', 'priceUploadsUrl'], window)
        // create formdata needed for axios request
        const formData = new FormData()

        if (!init) {
          data = pathOr('', ['data'])(await fetchHotelsList(paramsString))
          data.brand_statement = Array.isArray(data.brand_statement) ? data.brand_statement : []
          // move not available items to the bottom of list
          const available = data.results.filter(r => r.available === true)
          const notAvailable = data.results.filter(r => r.available === false)
          data.results = available.concat(notAvailable)
          dispatch(setValue(false, omit(['dataLayer'], data)))
          dataLayerPush(data.dataLayer)
        } else {
          data = searchResults
          data.brand_statement = Array.isArray(data.brand_statement) ? data.brand_statement : []
          dispatch(setValue(false, omit(['dataLayer'], data)))


          if (params.has(SEARCH_PARAM_DATE_START) && params.has(SEARCH_PARAM_DATE_END)) {
            const dateStart = params.get(SEARCH_PARAM_DATE_START)
            const dateEnd = params.get(SEARCH_PARAM_DATE_END)
            let priceRangeParam = ''
            let amenitiesParam = ''
            let hotelTypeParam = ''
            let sortParam = ''
            let roomsParams = ''
            const apartments = []

            if (params.has(SEARCH_PARAM_PRICE_RANGE)) {
              priceRangeParam = params.get(SEARCH_PARAM_PRICE_RANGE)
            }
            if (params.has(SEARCH_PARAM_AMENITIES)) {
              amenitiesParam = params.get(SEARCH_PARAM_AMENITIES)
            }
            if (params.has(SEARCH_PARAM_HOTEL_TYPE)) {
              hotelTypeParam = params.get(SEARCH_PARAM_HOTEL_TYPE)
            }
            if (params.has(SEARCH_PARAM_SORT)) {
              sortParam = parseInt(params.get(SEARCH_PARAM_SORT), 10)
            }

            const paramsV3 = {
              dateIn: dateStart,
              nights: dateEnd,
              price_range: priceRangeParam,
              amenities: amenitiesParam,
              hotel_type: hotelTypeParam,
              sort: sortParam,
              prefCodes: `${pathOr('', ['drupalSettings', 'searchResults', 'prefCodes'], window)}`,
            }
            // append apartments to params
            if (params.has(SEARCH_PARAM_ROOM) && params.get(SEARCH_PARAM_ROOM) !== '') {
              roomsParams = params.getAll(SEARCH_PARAM_ROOM)
              roomsParams.forEach((room) => {
                const r = room.split(',')
                apartments.push(r)
                formData.append('params[apartment[]]', r)
              })
            }

            // append params to formdata
            Object.entries(paramsV3).forEach(
              ([key, value]) => {
                formData.append(`params[${key}]`, value)
              },
            )
            // get ids of received hotels
            const hotelIds = data.results.map(item => item.id)
            // append hotels id to formdata
            hotelIds.forEach((item) => {
              formData.append('hotelsCodes[]', item)
            })

            // send request to get hot data from v3
            await axios.post(apiV3Url, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }).then((response) => {
              // add received data from v3 to correspond by Id
              // if only one hotel go to room rates
              if (response.data.length === 0) return // if no data from request
              if (response.data.availabilities.length === 1 && response.data.availabilities[0].available === true) {
                const resultsDS = pathOr(null, ['drupalSettings', 'searchResults', 'results'], window)
                const linkToRoomRates = resultsDS[0].reserveBtnUrl
                const paramsToRoomRate = new URLSearchParams(window.location.search)
                if (paramsToRoomRate.has(SEARCH_PARAM_TO_ROOM_RATES) && linkToRoomRates !== null) {
                  // remove to Room rates query
                  params.delete(SEARCH_PARAM_TO_ROOM_RATES)
                  window.history.replaceState({}, '', `?${paramsToRoomRate.toString()}`)
                  window.location = linkToRoomRates
                } else if (paramsToRoomRate.has(SEARCH_PARAM_TO_ROOM_RATES)) {
                  // remove to Room rates query
                  params.delete(SEARCH_PARAM_TO_ROOM_RATES)
                  window.history.replaceState({}, '', `?${paramsToRoomRate.toString()}`)
                }
              } else {
                // creating deep copy of data to force react rerender component
                // when redux state changed
                const deepCopyData = JSON.parse(JSON.stringify(data))
                deepCopyData.results.forEach((itemV2, iV2) => {
                  response.data.availabilities.forEach((itemV3, iV3) => {
                    // eslint-disable-next-line max-len
                    if (String(deepCopyData.results[iV2].id) === String(response.data.availabilities[iV3].id)) {
                      deepCopyData.results[iV2] = {
                        ...deepCopyData.results[iV2],
                        ...response.data.availabilities[iV3],
                      }
                    }
                  })
                })

                // move not available items to the bottom of list
                const available = deepCopyData.results.filter(r => r.available === true)
                const notAvailable = deepCopyData.results.filter(r => r.available === false)
                deepCopyData.results = available.concat(notAvailable)
                dispatch(setValue(false, omit(['dataLayer'], deepCopyData)))
              }
            })
              .catch((error) => {
                console.error(error)
              })
          }
        }

        if (data.redirect) {
          if (isDesktop(browser) && (isHomePage || isBasicPage || isOfferPage || isOfferIndexPage || isDestinationsAllPage)) {
            // hold search url until search button click
            dispatch(setSearchUrlFiltersHolder(paramsString))
          } else if (isDestinationPage && data.redirect.includes('apartment')) { // check if rooms selected
            window.location = data.redirect
          } else if (!isDestinationPage) {
            window.location = data.redirect
          }
        }

        dispatch(toggleGlobalLoader(false))
      } catch (e) {
        const data = pathOr({}, ['response', 'data'], e)
        isSuccess = false

        dispatch(toggleGlobalLoader(false))
        if (data.message) {
          dispatch(openPopup(GLOBAL_ERROR_POPUP, data))
        }
      }
  }

  /**
   * We have to change URL params on filters apply (submit) for all pages with filters in header.
   */
  if (isSuccess && !init) {
    if (paramsString) {
      /** Search with filters widget logic */
      if (isDesktop(browser) && (isHomePage || isBasicPage || isOfferPage || isOfferIndexPage || isDestinationsAllPage)) {
        // hold search url until search button click
        dispatch(setSearchUrlFiltersHolder(paramsString))
        // eslint-disable-next-line no-empty
        if (!isFirstGetSearchResults) {
          window.history.replaceState({}, '', paramsString)
        } else if (isFirstGetSearchResults && !isInitialParamsEmpty) {
          window.history.replaceState({}, '', paramsString)
        }
      } else {
        window.history.replaceState({}, '', paramsString)
      }
    }
    if (doReload) {
      document.location.reload(true)
    }
  }

  isFirstGetSearchResults = false
}

export default (searchParams, init = false) => (
  dispatch, getState,
) => getSearchResults(dispatch, getState, searchParams, init)
